import {
  AddToMode,
  FormStatus,
  FormsListSortBy,
  GetFormsParams
} from '../types';

const SORT_BY_FROM_API: Record<string, FormsListSortBy> = {
  name: 'name',
  paid_count: 'registrationCount',
  conversion_rate: 'conversionRate'
};

export const parseFormsListQueryFromUrl = (url: URL): GetFormsParams => {
  const status = url.searchParams.get('status');
  const addTo = url.searchParams.get('add_to');
  const search = url.searchParams.get('search') ?? undefined;
  const page = Number(url.searchParams.get('page') ?? '0');
  const limit = Number(url.searchParams.get('limit') ?? '10');
  const sortBy = url.searchParams.get('sort_by');
  const sortOrder = url.searchParams.get('sort_order');

  const params: GetFormsParams = { page, limit };

  if (status) {
    params.status = status.split(',') as FormStatus[];
  }
  if (addTo) {
    params.addTo = addTo.split(',') as AddToMode[];
  }
  if (search) {
    params.search = search;
  }
  if (sortBy && SORT_BY_FROM_API[sortBy]) {
    params.sortBy = SORT_BY_FROM_API[sortBy];
    if (sortOrder === 'asc' || sortOrder === 'desc') {
      params.sortOrder = sortOrder;
    }
  }

  return params;
};

export default parseFormsListQueryFromUrl;
